import 'slick-carousel';

$(document).ready(function () {
    if ($('.entity-slider').length > 0) {

        const previous = typeof skTranslate === "undefined" ? "Forrige" : skTranslate["/slick"]["/previous"];
        const next = typeof skTranslate === "undefined" ? "Neste" : skTranslate["/slick"]["/next"];

        $('.entity-slider .slides').slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            centerMode: true,
            variableWidth: true,
            prevArrow: '<button type="button" data-role="none" class="slick-prev" aria-label="' + previous + '" tabindex="0" role="button"></button>',
            nextArrow: '<button type="button" data-role="none" class="slick-next" aria-label="' + next + '" tabindex="0" role="button"></button>'
        });

    }
});